export default {
  init() {
    // JavaScript to be fired on the home page
  },
  finalize() {
    var $anchorList = $('#anchor-list.slick-slider');

    /* Anchor Nav */
    document.querySelectorAll('a[href^="#"]').forEach(anchor => {
      anchor.addEventListener('click', function (e) {
        e.preventDefault();
        document.querySelector(this.getAttribute('href')).scrollIntoView({
          behavior: 'smooth',
        });
      });
    });
    /* end Anchor Nav */
    $(window).on('load resize orientationchange', function() {
      $('#anchor-list').each(function(){
        var $carousel = $(this);
        /* Initializes a slick carousel only on mobile screens */
        // slick on mobile
        if ($(window).width() > 991) {
          if ($carousel.hasClass('slick-initialized')) {
            $carousel.slick('unslick');
          }
        }
        else{
          if (!$carousel.hasClass('slick-initialized')) {
            $carousel.slick({
              slidesToShow: 1,
              slidesToScroll: 1,
              speed: 500,
              infinite: false,
              mobileFirst: true,
              adaptiveHeight: false,
              responsive: [
                {
                  breakpoint: 768,
                  settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3,
                  },
                },
              ],
            });
          }
        }
      });
    });

    var windowHeight = $(window).height(),
        gridTop = windowHeight * 0.25,
        gridBottom = windowHeight * 0.75,
        currentAnchor = 0;

    $(window).on('scroll', function(){
      if ($(window).scrollTop() >= gridBottom) {
        $('#anchor-list').addClass('nav-focused');
        $('.anchor-nav').addClass('active');
      } else {
        $('#anchor-list').removeClass('nav-focused');
        $('.anchor-nav').removeClass('active');
        $anchorList.slick('slickGoTo', 0, true );
      }

      setInterval(function() {
        $('.anchor h2').each(function(index) {
          var thisTop = $(this).offset().top - $(window).scrollTop();

          if (thisTop > gridTop && (thisTop + $(this).height()) < gridBottom) {
            $(this).addClass('anchor-shown');
            $('#anchor-list li').removeClass('current-nav-item');
            $('#anchor-list li:eq(' + index + ')').addClass('current-nav-item');
            if (currentAnchor !== index) {
              if ($(window).width() < 992) {
                $('#anchor-list').slick('slickGoTo', index, false);
              }
            }
            currentAnchor = index;
          }
        });
      },750);
    });
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/anchors.js